import React, { FC, ReactNode, ReactElement, createContext, useState, useMemo, useEffect } from "react";
import { useGetMstrCategoriesResponseDataQuery } from "utils/redux/api/displayDataApiSlice";
import { MasterCategoriesNames } from "types/view";

// Set Props type.
type Props = { children: ReactNode };

export type DisplayDataType = {
  masterCategoriesData: MasterCategoriesNames[];
  setMasterCategoriesData: React.Dispatch<React.SetStateAction<MasterCategoriesNames[]>>;
  screenNames: Record<string, string>;
};

export const DisplayDataContext = createContext<DisplayDataType>({
  masterCategoriesData: [],
  setMasterCategoriesData: () => null,
  screenNames: null,
});

const DisplayDataContextProvider: FC<Props> = ({ children }): ReactElement => {
  const { data } = useGetMstrCategoriesResponseDataQuery();

  const [masterCategoriesData, setMasterCategoriesData] = useState([]);
  const [screenNames, setScreenNames] = useState<Record<string, string>>({});

  useEffect(() => {
    setMasterCategoriesData(data?.prodMstrCategories);
  }, [data]);

  useEffect(() => {
    if (masterCategoriesData && masterCategoriesData.length > 0) {
      const newScreenNames = masterCategoriesData.reduce((acc, { category, screenName }) => {
        acc[category] = screenName;
        return acc;
      }, {} as Record<string, string>);

      setScreenNames(newScreenNames);
    }
  }, [masterCategoriesData]);

  const value = useMemo(
    () => ({
      masterCategoriesData,
      setMasterCategoriesData,
      screenNames,
    }),
    [masterCategoriesData, setMasterCategoriesData, screenNames],
  );
  return <DisplayDataContext.Provider value={value}>{children}</DisplayDataContext.Provider>;
};

export default DisplayDataContextProvider;
